export default __webpack_public_path__ + "static/media/casino-xbit-main-banner.53ea82d8.jpg";